export const CUSTOMER_REQUEST = 'CUSTOMER_REQUEST';
export const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS';
export const CUSTOMER_FAILURE = 'CUSTOMER_FAILURE';
